import type { SiteConfig } from '../stores/app';
import type { RouteLocationNormalized } from 'vue-router';

export const getMenus = (config: SiteConfig) => {
  return [
    {
      name: '首页',
      path: '/',
      isRouter: true,
      getActive: (route: RouteLocationNormalized) => route.path === '/',
    },
    {
      name: '大会议程',
      path: '/#schedule',
      isRouter: true,
    },
    // {
    //   name: '大会嘉宾',
    //   path: '/speaker/index',
    //   isRouter: true,
    //   disabled: config.speakerTotal <= 0,
    //   getActive: (route: RouteLocationNormalized) => route.path === '/speaker/index',
    // },
    {
      name: '生态交流区',
      path: '/picture/index',
      isRouter: true,
      disabled: config.pictureTotal <= 0,
      getActive: (route: RouteLocationNormalized) => route.path === '/picture/index',
    },
    // {
    //   name: '最新资讯',
    //   path: '/journalism/index',
    //   isRouter: true,
    //   getActive: (route: RouteLocationNormalized) => route.path === '/journalism/index' || route.name === 'journalismDetail',
    // },
    {
      name: '大会手册',
      path: config.guideUrl,
      isRouter: false,
      disabled: !config.guideUrl,
    },
  ].filter(item => !item.disabled);
}
